import React, { useEffect, useState } from "react";
import {
  Box,
  Divider,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";

import { HeroSection } from "../utils/home/hero-section";
import { LiveRacesSection } from "../utils/home/live-races-section";
import { ChatSection } from "../utils/home/chat-section";
import { UserProfile } from "../utils/home/user-profile";
import englishTranslations from "../../i18n/translations/en";
import GradientButton from "../utils/gradient-button";
import { assetIcons, assetImages } from "../../constants/assets";
import FindMatchButton from "../utils/home/find-match-button";
import FindingMatchButton from "../utils/home/finding-match-button";
import LoadingModal from "../utils/popups/match-info-popup";
import { useLocation, useNavigate } from "react-router-dom";
import routes from "../../constants/routes";
import MatchFinder from "../utils/finding-match-timer";
import useApiRequest from "../../api/api";
import apiRoutes from "../../api/routes";
import { formatStreamDuration } from "../utils/format/time";
import LoadingBackdrop from "../utils/loader";
import { useUser } from "../../context/user-context";
import HomePageSkeleton from "./home-skeleton";
import { useSnackbar } from "../utils/SnackbarProvider";

export default function Home() {
  const navigate = useNavigate();
  const theme = useTheme();

  const isMediumScreen = useMediaQuery(theme.breakpoints.down("lg"));
  const { makeApiCall } = useApiRequest();
  const [isLoading, setIsLoading] = useState(false);

  const handleRaceCardClick = (id) => {
    navigate(`/race?id=${id}`);
  };
  const handleImage2Click = () => {
    window.open(
      "https://planetj.bet/community/article?id=a771e495-ec9f-4297-a62e-007b9d54d3db",
      "_blank",
      "noopener,noreferrer"
    );
  };

  const handleImage3Click = () => {
    window.open("https://indoxnito.com/", "_blank", "noopener,noreferrer");
  };
  const carouselSlides = [
    {
      id: 1,
      backgroundImage: assetImages.homePageNewBg1,
      athleteImage: assetImages.homePageAthlete,
      specialEvent: englishTranslations.home.specialEvent,
      title: englishTranslations.home.doubleWinnings,
      description: englishTranslations.home.betOnRaces,
      buttonText: englishTranslations.home.betNowButton,
      // onButtonClick: handleBetNowClick,
    },
    {
      id: 2,
      backgroundImage: assetImages.homePageNewBg2,
      athleteImage: assetImages.homePageAthlete,
      specialEvent: englishTranslations.home.specialEvent,
      title: englishTranslations.home.doubleWinnings,
      description: englishTranslations.home.betOnRaces,
      buttonText: englishTranslations.home.betNowButton,
      onButtonClick: handleImage2Click,
    },
    {
      id: 3,
      backgroundImage: assetImages.homePageNewBg3,
      athleteImage: assetImages.homePageAthlete,
      specialEvent: englishTranslations.home.specialEvent,
      title: englishTranslations.home.doubleWinnings,
      description: englishTranslations.home.betOnRaces,
      buttonText: englishTranslations.home.betNowButton,
      onButtonClick: handleImage3Click,
    },

    // Add more slides as needed
  ];
  const handleNavigateToRace = (id) => {
    navigate(`${routes.race}?id=${id}`);

    // Perform navigation or additional logic if required
  };
  const [races, setRaces] = useState([]);
  const fetchRaces = async () => {
    setIsLoading(true);

    try {
      const response = await makeApiCall(apiRoutes.races.list, "GET");
      if (response?.data) {
        const mappedRaces = response.data.map((race) => ({
          id: race.identifier, // Map the 'identifier' as 'id'
          title: race.name, // Map the 'name' as 'title'
          time: formatStreamDuration(race.startTime), // Store startTime for future updates
          runners: `${race.racers.length} `, // Calculate the number of runners
          backgroundImage: race.imageUrl, // Map 'imageUrl' to 'backgroundImage'
        }));

        // Set the mapped races to the state
        setRaces(mappedRaces);
      }
    } catch (error) {
      console.error("Failed to fetch races:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchRaces();
  }, []);

  return (
    <>
      {isLoading ? (
        <HomePageSkeleton isMediumScreen={isMediumScreen} />
      ) : (
        <Box
          sx={{
            display: "flex",
            height: "100vh",
          }}
        >
          {/* Left side - scrollable content */}
          <Box
            sx={{
              flex: 1,
              overflowY: "auto",
              p: isMediumScreen ? 2.5 : "15px",
              pt: "38px",
              pl: isMediumScreen ? "auto" : "38px",
              height: "auto",
              mb: 2,
              // mt: 4,
              "&::-webkit-scrollbar": {
                display: "none", // Hide scrollbar in WebKit browsers (Chrome, Safari)
              },
            }}
          >
            <HeroSection slides={carouselSlides} />
            {isMediumScreen && (
              <Box mt={5}>
                <MatchFinder
                  onNavigate={handleNavigateToRace} // Custom navigation logic
                />
              </Box>
            )}

            <Box mt={5}>
              <LiveRacesSection races={races} onClick={handleRaceCardClick} />
            </Box>
          </Box>

          {/* Right side - fixed content */}
          {!isMediumScreen && (
            <Box
              sx={{
                width: { lg: 370, sm: 300 },
                p: 3,
                height: "auto",
                overflowY: "auto",
                "&::-webkit-scrollbar": {
                  display: "none", // Hide scrollbar in WebKit browsers (Chrome, Safari)
                },
              }}
            >
              <UserProfile />
              <Box mt={3}></Box>
              <ChatSection />

              {/* Find Random Match Button */}

              <Box
                display={"flex"}
                justifyContent={"left"}
                mt={2}
                sx={{ mb: 11 }}
              >
                <MatchFinder
                  onNavigate={handleNavigateToRace} // Custom navigation logic
                />
              </Box>
            </Box>
          )}
        </Box>
      )}
    </>
  );
}
